export default __webpack_public_path__ + "static/media/Adil.13e20617.jpg";